/** @jsx jsx */
import { jsx } from '@emotion/core';

import React from 'react';
import { MultiSelect, MultiSelectOption } from '@americanexpress/dls-react';
import advFormStyles from '../../../styles/AdvancedFormSearch/AdvanceFormSearchStyles';

const AdvFormMutilSelectItem = React.memo(({
  formField, pageData, setPageData,
}) => {
  const {
    id, name, suggestionList, selectedIds,
  } = formField;

  const handleOnChange = (selectedItemId, selected) => {
    const updatedPageData = { ...pageData };
    console.log('handleOnChange for AdvFormMutilSelectItem');
    if (updatedPageData.formFields[id].selectedIds) {
      if (selected) {
        updatedPageData.formFields[id].selectedIds.push(selectedItemId);
      } else {
        const index = updatedPageData.formFields[id].selectedIds.indexOf(selectedItemId);
        if (index > -1) {
          updatedPageData.formFields[id].selectedIds.splice(index, 1);
        }
      }
      if (updatedPageData.formFields[id].selectedIds && updatedPageData.formFields[id].selectedIds.length > 0) {
        updatedPageData.formFields[id].value = updatedPageData.formFields[id].selectedIds.join(',');
      } else if (updatedPageData.formFields[id].nothingSelectedVal) {
        updatedPageData.formFields[id].value = updatedPageData.formFields[id].nothingSelectedVal;
      } else {
        updatedPageData.formFields[id].value = '';
      }
    }

    setPageData(updatedPageData);
  };

  return (
    <div>
      <MultiSelect
        id={name}
        css={advFormStyles['.fullWidth']}
        onChange={(e, v) => handleOnChange(e, v)}
        style={{ zIndex: 'auto' }}
      >
        {suggestionList.map((e) => (
          <MultiSelectOption
            key={e.id}
            id={e.id}
            selected={selectedIds.includes(e.id)}
            label={e.name}
            value={e.value}
          />
        ))}
      </MultiSelect>

    </div>
  );
});

export default AdvFormMutilSelectItem;
